export default __webpack_public_path__ + "static/media/search.e4ed4baa.svg";